import { Box, styled } from "@mui/material";
import { unstable_styleFunctionSx as resolveSystemStyles } from "@mui/system";

export const StyledInputError = styled(Box)(({ theme }) => ({
  position: "absolute",
  display: "flex",
  gap: theme.spacing(2),
  alignItems: "center",
  left: "16px",
  bottom: "-20px",
}));

export const StyledInputErrorBox = styled(Box, {
  skipSx: true,
  shouldForwardProp: (prop) => !["sx"].includes(String(prop)),
})(({ theme, sx }) =>
  resolveSystemStyles({
    theme,
    sx: { position: "relative", width: "100%", ...sx },
  })
);
